import React, { useLayoutEffect } from "react";
import { useNavigate } from "react-router-dom";

interface RedirectRouteProps {
  page: string;
}

const RedirectRoute: React.FC<RedirectRouteProps> = ({ page }: RedirectRouteProps) => {
  const navigator = useNavigate();

  useLayoutEffect(() => {
    navigator(page);
  }, []);

  return <></>;
};

export default RedirectRoute;
